import React, { useContext, useEffect, useRef, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from "formik";
import { getImages } from '../../Common/const'
import ValidationError from '../../Errors/ValidationError';
import { VehicleContext } from '../../Context/VehicleContext';
import ReCAPTCHA from 'react-google-recaptcha';

const SellVehicleModal = ({ close, sellCarData, checkForm }) => {


    const { submitContactForm, uploadDocument } = useContext(VehicleContext);
        
    const recaptchaRef = React.useRef();
    
    const formikRef = useRef();

    const [formSubmitted,setFormSubmitted] = useState(false);
    
    const [selectedImages, setSelectedImages] = useState([]);
    const handleImageChange = (event, setFieldValue) => {
        const files = Array.from(event.target.files);

        const newImages = files.map(file => ({'file':URL.createObjectURL(file),'name':file.name}));
        setSelectedImages(prevImages => [...prevImages, ...newImages]);
        //setFieldValue('photos', event.target.files);

        uploadFiles(event.target.files);
    };

    const handleDrop = (event, setFieldValue) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        const newImages = files.map(file => ({'file':URL.createObjectURL(file),'name':file.name}));
        setSelectedImages(prevImages => [...prevImages, ...newImages]);
        //setFieldValue('photos', event.dataTransfer.files);

        uploadFiles(event.dataTransfer.files);
    };

    const uploadFiles = (files) => {
        Array.from(files).map((v, i) => {
            uploadFile(v);
        });
    }

    const uploadFile = (file) => {
        console.log(file);

        if (file) {

            const formData = new FormData();
            formData.append('file', file);
            formData.append('folder', 'userappraisals/');
            formData.append('fileName', file.name);
            //formData.append('base_url',true);

            const upload = uploadDocument(formData);
            upload.then((data) => {
                if (data.url && data.data && data.data.key) {

                    formikRef.current.setFieldValue("photos", [...formikRef.current.values.photos, data.url]);

                    console.log(formikRef.current.values);



                } else if (data.error) alert(data.error);
            });
        }

    }

    const handleRemoveImage = (image) => {
        setSelectedImages(prevImages => prevImages.filter(img => img !== image));
    };

    const defaultValues = {
        location: "San Clemente, CA",
        additional_recipient: true,
        vin: "",
        int_color: "",
        ext_color: "",
        first_name: "",
        last_name: "",
        phone: "",
        comments: "",
        carPhotos: "Yes",
        photos: [],
        salesforce_form: true
    };

    useEffect(() => {

        console.log("modal open",checkForm,formSubmitted,formikRef.current)
        

        if(!formSubmitted && formikRef.current && checkForm > 0) {
            console.log("submitting form");
            formikRef.current.submitForm();
            setFormSubmitted(true);
        }
    },[checkForm]);
    
    return (
        <>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title filter-modal-title text-uppercase text-center fw-900 eurostile w-100">
                        Sell Your Car
                    </h1>
                    <button className="sm-box-close" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                </div>
                <div className="modal-body sell-car-body">
                    <div className='sell-car-box'>
                        <div className='md-title eurostile fw-700 mb-md-5 mb-3'>Final Details & Contact Info</div>
                        <Formik
                            enableReinitialize={true}
                            initialValues={{ ...defaultValues }}
                            innerRef={formikRef}
                            onSubmit={async (values, { resetForm }) => {

                                 const token = await recaptchaRef.current.executeAsync();
                                 recaptchaRef.current.reset(); // Reset after use
                              
                                 values = { ...values, ...sellCarData, token: token };

                                 console.log("Form Values:", values);

                                 const data = await submitContactForm(values);

                                 setFormSubmitted(true);

                                 if (data.success) {
                                     resetForm();
                                     alert("Thank you for your submission. We'll be in touch soon!");
                                     close();
                                 } else
                                     alert("There was a problem with your submission");
                            }}
                        >
                            {({ values, setFieldValue }) => (
                                <Form className="custom-form sellcar-contact-form">
                                    <Field type="hidden" name="salesforce_form" value={true} />
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey="6LckXRIsAAAAAAiOe2UBkXy7Uy-ROdiueqrr4Lzk" // Replace with your actual site key
                                        size="invisible"
                                    /> 
                                    <div className="row mlr-40">
                                        {/* left side fields */}
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-12 form-group">
                                                    <div className="cs-label mb-1">VIN</div>
                                                    <Field name="vin" className="form-control" />
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <div className="cs-label mb-1">Exterior Color</div>
                                                    <Field name="ext_color" className="form-control" />
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <div className="cs-label mb-1">Interior Color</div>
                                                    <Field name="int_color" className="form-control" />
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <div className="cs-label mb-1">First Name</div>
                                                    <Field name="first_name" className="form-control" />
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <div className="cs-label mb-1">Last Name</div>
                                                    <Field name="last_name" className="form-control" />
                                                </div>

                                                <div className="col-12 form-group">
                                                    <div className="cs-label mb-1">Phone</div>
                                                    <Field name="phone" className="form-control" />
                                                </div>
                                            </div>
                                        </div>

                                        {/* right side fields */}
                                        <div className="col-md-6">
                                            <div className="form-group mb-md-4 pb-md-2">
                                                <div className="xs-title fw-700 text-uppercase font-14 mt-2 mb-3">
                                                    Do you have photos of your car?
                                                </div>

                                                <div className="location-options d-flex">
                                                    <label className="custom-radio text-uppercase me-md-5 me-4">
                                                        <Field type="radio" name="carPhotos" value="Yes" />
                                                        <span className="radio-mark"></span> Yes
                                                    </label>

                                                    <label className="custom-radio text-uppercase">
                                                        <Field type="radio" name="carPhotos" value="No" />
                                                        <span className="radio-mark"></span> No
                                                    </label>
                                                </div>
                                            </div>

                                            {/* File Upload Component */}
                                            {values.carPhotos === "Yes" && (
                                                
                                            <div className="form-group">
                                                <div
                                                    className="drag-box"
                                                    onDragOver={(e) => e.preventDefault()}
                                                    onDrop={(event) => handleDrop(event, setFieldValue)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <div className="drag-icon mb-2 d-none d-md-block">
                                                        <img src={getImages("icon-upload-photo.svg")} />
                                                    </div>                                            
                                                    <div className="xs-title font-15 text-center avenir-next fw-500 text-uppercase text-gray d-none d-md-block">
                                                        Drag Photos Here
                                                    </div>                                            
                                                    <div className="mt-3 text-center">
                                                        <label className="drag-upload-btn d-inline-block">
                                                            Choose File
                                                            <input
                                                            type="file"
                                                            multiple
                                                            style={{ display: "none" }}
                                                            onChange={(event) => handleImageChange(event, setFieldValue)}
                                                            />
                                                        </label>
                                                    </div>
                                            
                                                    {/* Show uploaded file names */}
                                                    {selectedImages.length > 0 && (
                                                    <div className="mt-3 small text-center text-white">
                                                        {selectedImages.map((file, index) => (
                                                            <div key={index}>{file.name}</div>
                                                        ))}
                                                    </div>
                                                    )}
                                                </div>
                                            </div>
                                            )}
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                    <div className="cs-label mb-0">Comments</div>
                                                    <div className="cs-require">(Optional)</div>
                                                </div>
                                                <Field as="textarea" name="comments" className="form-control h-90" rows="4" />
                                            </div>
                                        </div>

                                        {/* <div className="col-12 mt-md-4 mt-2">
                                            <div className="sl-location-box">
                                                <div className="d-md-flex align-items-center">
                                                    <div className="xs-title fw-600 text-uppercase mb-4 mb-md-0">Select Location</div>
                                                    <div className="location-options d-md-flex ms-auto">
                                                        <label className="custom-radio me-md-5 mb-3 mb-md-0">
                                                            <Field type="radio" name="location" value="TAMPA, FL" />
                                                            <span className="radio-mark"></span> Tampa, FL
                                                        </label>
                                                        <label className="custom-radio">
                                                            <Field type="radio" name="location" value="SAN CLEMENTE, CA" />
                                                            <span className="radio-mark"></span> San Clemente, CA
                                                        </label>
                                                    </div>
                                                </div>
                                                <ErrorMessage
                                                    name="location"
                                                    component="div"
                                                    className="text-danger small"
                                                />
                                            </div>
                                        </div> */}
                                        <div className="col-12 text-center mt-60">
                                            <button type="submit" className="orange-white-btn fw-700 text-uppercase lg-btn px-5 d-inline-block w-375">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                    </div>
                </div>
            </div>
        </>
    )
}

export default SellVehicleModal